<div class="flex-between-center mb-5 btn-group gap-x-3 overflow-y-visible max-md:overflow-x-auto">
    <div class="flex-start-center gap-x-3">
        <button
            nz-button
            class="max-md:!text-xs"
            [ngClass]="{'!border-line !text-sub-text': sort === 'subscriber_count'}"
            nz-dropdown
            [nzDropdownMenu]="menu"
            [nzPlacement]="'bottomLeft'"
            nzTrigger="click"
        >
            <nz-avatar-group *ngIf="sort === 'pnl_7d'">
                <nz-avatar nzSrc="/assets/imgs/chains/solana.png" class="!w-[18px] !h-[18px] rounded-full" alt="" />
                <nz-avatar nzSrc="/assets/imgs/chains/base.png" class="!w-[18px] !h-[18px] rounded-full" alt="" />
                <nz-avatar nzSrc="/assets/imgs/chains/bnb.png" class="!w-[18px] !h-[18px] rounded-full" alt="" />
            </nz-avatar-group>

            <img *ngIf="sort === 'pnl_7d_sol'" src="/assets/imgs/chains/solana.png" class="w-[18px] h-[18px] rounded-full" alt="" />
            <img *ngIf="sort === 'pnl_7d_base'" src="/assets/imgs/chains/base.png" class="w-[18px] h-[18px] rounded-full" alt="" />
            <img *ngIf="sort === 'pnl_7d_bsc'" src="/assets/imgs/chains/bnb.png" class="w-[18px] h-[18px] rounded-full" alt="" />

            <span class="ml-2">Pnl</span>
            <span nz-icon nzType="antd:sorter-down" class="text-xl"></span>
        </button>

        <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
                <li nz-menu-item (click)="sortChange('pnl_7d')">
                    <div class="flex-start-center gap-x-2 text-sm">
                        <nz-avatar-group>
                            <nz-avatar nzSrc="/assets/imgs/chains/solana.png" class="!w-[18px] !h-[18px] rounded-full" alt="" />
                            <nz-avatar nzSrc="/assets/imgs/chains/base.png" class="!w-[18px] !h-[18px] rounded-full" alt="" />
                            <nz-avatar nzSrc="/assets/imgs/chains/bnb.png" class="!w-[18px] !h-[18px] rounded-full" alt="" />
                        </nz-avatar-group>
                        <span>Pnl</span>
                    </div>
                </li>

                <li nz-menu-item (click)="sortChange('pnl_7d_sol')">
                    <div class="flex-start-center gap-x-2 text-sm">
                        <img src="/assets/imgs/chains/solana.png" class="w-[18px] h-[18px] rounded-full" alt="" />
                        <span>Pnl</span>
                    </div>
                </li>

                <li nz-menu-item (click)="sortChange('pnl_7d_base')">
                    <div class="flex-start-center gap-x-2 text-sm">
                        <img src="/assets/imgs/chains/base.png" class="w-[18px] h-[18px] rounded-full" alt="" />
                        <span>Pnl</span>
                    </div>
                </li>

                <li nz-menu-item (click)="sortChange('pnl_7d_bsc')">
                    <div class="flex-start-center gap-x-2 text-sm">
                        <img src="/assets/imgs/chains/bnb.png" class="w-[18px] h-[18px] rounded-full" alt="" />
                        <span>Pnl</span>
                    </div>
                </li>
            </ul>
        </nz-dropdown-menu>

        <button
            nz-button
            class="max-md:!text-xs"
            [ngClass]="{'!border-line !text-sub-text': sort !== 'subscriber_count'}"
            (click)="sortChange('subscriber_count')"
        >
            Subscribers
            <span nz-icon nzType="antd:sorter-down" class="text-xl"></span>
        </button>
        <button
            nz-button
            class="max-md:!text-xs"
            [ngClass]="{'!border-line !text-sub-text': !subscribeFilterActive}"
            (click)="subscribeFilterActive = !subscribeFilterActive; filterChange()"
            [disabled]="!isAuthenticated"
        >
            <nz-switch
                [(ngModel)]="subscribeFilterActive"
                [nzSize]="commonService.isMobile ? 'small' : 'default'"
                (ngModelChange)="filterChange()"
                (click)="$event.stopPropagation()"
                [disabled]="!isAuthenticated"
            ></nz-switch>
            <span class="ml-1.5">Subscribed</span>
        </button>
    </div>

    <!-- 如果有watchlist -->
    <button
        *ngIf="isWatchListAdded"
        nz-button
        [ngClass]="{'!border-line': true}"
        class="min-w-fit max-md:text-xs"
        [routerLink]="['/meme-dashboard/my-watchlist']"
    >
        <img [src]="watchlistAgentImg || userService.userAvatar" class="w-5 h-5 md:w-7 md:h-7 rounded-full mr-1" alt="" />
        My Watchlist
    </button>

    <!-- 如果没有 watchlist -->
    <div *ngIf="!isWatchListAdded" class="flex-start-center h-9 md:h-11 px-2 md:px-2.5 rounded-lg border border-line relative !pr-[30px] md:!pr-[42px]">
        <span class="text-sub-text max-md:text-xs whitespace-nowrap">Create My Watchlist</span>

        <div class="h-5 w-[1px] bg-line mx-3"></div>

        <div class="w-6 h-6 md:w-7 md:h-7">
            <div
                [@tada]="bounceStatus"
                class="relative flex-center-center gap-x-1 min-w-6 w-6 h-6 md:w-7 md:h-7 rounded-md bg-gradient transition-colors cursor-pointer"
                (click)="goMyWatchlist()"
            >
                <span nz-icon nzType="plus" class="text-xs md:text-lg" nzTheme="outline"></span>
            </div>
        </div>

        <div class="bonus-watchlist-points">
            <img src="/assets/imgs/icon/sun-v2.png" class="w-[14px]" alt="" />
            <span>+100</span>
        </div>
    </div>
</div>

<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-5">
    <app-watchlist-agent-card *ngFor="let item of watchlistAgents" [agentInfo]="item"></app-watchlist-agent-card>
</div>

<nz-skeleton *ngIf="!isLastPage" [nzActive]="true" class="mt-5" appScrollObserver (scrolledIntoView)="fetchData()"></nz-skeleton>

<app-no-data *ngIf="isLastPage && !watchlistAgents.length" class="mt-5"></app-no-data>
